'use client';

import classnames from 'classnames';
import React, { useEffect, useState } from 'react';

import CinemaBlogTitleItem from '@/app/[locale]/(default-layout)/announcements/_components/CinemaBlogTitleItem';
import CinemaBlogTitleItemDropdown from '@/app/[locale]/(default-layout)/announcements/_components/CinemaBlogTitleItemDropdown';

import { CinemaBlogDto } from '@cineamo/api/models/cinema-blog/CinemaBlogDto.types';

import { useDomainConfiguration } from '@/providers/DomainConfigurationProvider';

const CinemaBlogsTitleList: React.FC<{ cinemaBlogs: CinemaBlogDto[] }> = ({ cinemaBlogs }) => {
    const domainConfiguration = useDomainConfiguration();
    const [selectedCinemaBlog, setSelectedCinemaBlog] = useState<CinemaBlogDto>(null);
    const [isExpanded, setIsExpanded] = useState<boolean>(false);

    function onCinemaBlogTitleClick(cinemaBlog: CinemaBlogDto) {
        setIsExpanded(false);
        setSelectedCinemaBlog(cinemaBlog);
    }

    function toggleDropdown() {
        setIsExpanded(!isExpanded);
    }

    useEffect(() => {
        if (!selectedCinemaBlog && cinemaBlogs.length > 0) {
            setSelectedCinemaBlog(cinemaBlogs[0]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cinemaBlogs]);

    return (
        <div className={classnames('w-full flex flex-col sticky top-0')}>
            {cinemaBlogs.length > 1 && (
                <CinemaBlogTitleItemDropdown
                    domainConfiguration={domainConfiguration}
                    selectedCinemaBlog={selectedCinemaBlog}
                    isExpanded={isExpanded}
                    toggleDropdown={toggleDropdown}
                />
            )}
            <div
                className={classnames(
                    'flex flex-col sticky top-0 overflow-auto',
                    'lg:max-h-[40dvh] duration-200',
                    isExpanded ? 'max-h-[40dvh]' : 'max-h-[0px]'
                )}>
                {cinemaBlogs.map((cinemaBlog, index) => (
                    <CinemaBlogTitleItem
                        key={`CinemaBlogTitleItem#${index}`}
                        cinemaBlog={cinemaBlog}
                        isSelected={selectedCinemaBlog?.id === cinemaBlog.id}
                        onClick={() => onCinemaBlogTitleClick(cinemaBlog)}
                    />
                ))}
            </div>
        </div>
    );
};

export default CinemaBlogsTitleList;
